import { Activity } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-background py-8">
      <div className="container-tight">
        <div className="grid grid-cols-1 items-center gap-6 md:grid-cols-3">
          
          <div className="flex items-center gap-2.5">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-dark shrink-0">
              <Activity className="h-4 w-4 text-signal" strokeWidth={2.5} />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground leading-none mb-1">Signal AI</p>
              <p className="text-[10px] text-muted-foreground leading-tight">
                A <span className="text-[11px] font-semibold tracking-[0.05em] text-[#090e1a]">
                  Gow
                  <span className="relative inline-flex flex-col items-center leading-none">
                    {/* Dot size reduced to 12px and position adjusted */}
                    <span className="text-[#1d66ff] absolute -top-[6.5px] left-1/2 -translate-x-1/2 text-[12px] leading-none">.</span>
                    <span className="text-[#090e1a] pt-[2px]">ı</span>
                  </span>
                  tek
                </span> product
              </p>
            </div>
          </div>

          <div className="flex justify-center text-center">
            <p className="text-xs text-muted-foreground whitespace-nowrap">
               consulting led • ai-first • roi driven
            </p>
          </div>

          <div className="flex md:justify-end">
            <p className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} Gowitek. All rights reserved.
            </p>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;